import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  Mensagem,
  ListarMensagensResponse,
  EnviarMensagemRequest,
  EnviarMensagemResponse,
} from '../models/mensagem.model';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MensagemService {
  private apiUrl = `${environment.apiUrl}/v1/WhatsAppMensagens`;

  constructor(
    private http: HttpClient,
    private toastService: ToastService
  ) {}

  listarMensagensPorConversa(conversaId: string): Observable<ListarMensagensResponse> {
    console.log('MensagemService: Listando mensagens da conversa', conversaId);
    return this.http
      .get<ListarMensagensResponse>(`${this.apiUrl}/conversa/${conversaId}`)
      .pipe(
        catchError((error) => {
          console.error('MensagemService: Erro ao listar mensagens', {
            conversaId,
            status: error.status,
            message: error.message
          });
          this.toastService.show('Erro ao listar mensagens', {
            classname: 'bg-danger text-light',
          });
          return throwError(() => error);
        })
      );
  }

  enviarMensagem(
    conversaId: string,
    mensagem: string,
    tipo: string = 'text'
  ): Observable<EnviarMensagemResponse> {
    const request: EnviarMensagemRequest = { conversaId, mensagem, tipo };
    const endpoint = `${this.apiUrl}/enviar`;
    
    console.log('MensagemService: Enviando mensagem', {
      endpoint,
      conversaId,
      mensagem: mensagem.substring(0, 50) + (mensagem.length > 50 ? '...' : ''),
      tipo
    });
    
    return this.http.post<EnviarMensagemResponse>(endpoint, request).pipe(
      catchError((error) => {
        console.error('MensagemService: Erro ao enviar mensagem', {
          conversaId,
          status: error.status,
          message: error.message,
          errors: error.error?.errors
        });
        
        // Mostrar erros específicos se disponíveis
        if (error.error?.errors && Array.isArray(error.error.errors)) {
          error.error.errors.forEach((err: string) => {
            this.toastService.show(err, {
              classname: 'bg-danger text-light',
            });
          });
        } else {
          this.toastService.show('Erro ao enviar mensagem', {
            classname: 'bg-danger text-light',
          });
        }
        
        return throwError(() => error);
      })
    );
  }

  /**
   * Marca todas as mensagens de uma conversa como lidas
   * PUT /api/v1/WhatsAppMensagens/conversa/{conversaId}/marcar-lida
   * @param conversaId ID da conversa (UUID)
   */
  marcarMensagensComoLidas(conversaId: string): Observable<any> {
    const endpoint = `${this.apiUrl}/conversa/${conversaId}/marcar-lida`;
    
    console.log('MensagemService: Marcando mensagens como lidas', {
      endpoint,
      conversaId
    });
    
    return this.http.put<any>(endpoint, {}).pipe(
      catchError((error) => {
        console.error('MensagemService: Erro ao marcar mensagens como lidas', {
          conversaId,
          status: error.status,
          message: error.message
        });
        
        // Não mostrar toast de erro para não poluir a interface
        // O erro é apenas logado, pois não é crítico para a funcionalidade
        return throwError(() => error);
      })
    );
  }
}
